export default __webpack_public_path__ + "static/media/privacy.c16747b7.pdf";